const { createContext, useState } = require("react");

export const SelectedOpenPartOrdersContext = createContext({
  selectedOpenPartOrders: [],
  setSelectedOpenPartOrders: () => {},
  resetSelectedOpenPartOrders: () => {},
  removeSelectedOpenPart: () => {},
});

export const SelectedOpenPartOrdersProvider = ({ children }) => {
  const [selectedOpenPartOrders, setSelectedOpenPartOrders] = useState([]);

  const resetSelectedOpenPartOrders = () => {
    setSelectedOpenPartOrders([]);
  };

  const removeSelectedOpenPart = (event) => {
    event.preventDefault();
    const { _id } = event.target.dataset;
    setSelectedOpenPartOrders(
      selectedOpenPartOrders.filter((part) => part._id !== _id)
    );
  };

  return (
    <SelectedOpenPartOrdersContext.Provider
      value={{
        selectedOpenPartOrders,
        setSelectedOpenPartOrders,
        resetSelectedOpenPartOrders,
        removeSelectedOpenPart,
      }}
    >
      {children}
    </SelectedOpenPartOrdersContext.Provider>
  );
};
